import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from '@catawiki/cata-style';
import { SignInLink } from './SignInLink';
import { SignUpLink } from './SignUpLink';
import { FAVOURITE_LOTS_PATH, HELP_PATH, SAVED_SEARCHES_PATH, SELLER_SETTINGS_PATH, } from '../paths';
import { FooterColumn } from '../shared/FooterColumn';
import { useIsUserLoggedIn } from '../../../../shared/hooks/useIsUserLoggedIn';
import { useLocale } from '../../../../hooks/useLocale';
export const MyCatawiki = () => {
    const isLoggedIn = useIsUserLoggedIn();
    const locale = useLocale();
    const { t } = useI18n();
    const items = [
        ...(!isLoggedIn
            ? [
                { content: _jsx(SignInLink, { label: t('login') }) },
                { content: _jsx(SignUpLink, { label: t('register') }) },
            ]
            : []),
        { content: t('footer_link_help_centre'), link: HELP_PATH(locale) },
        ...(isLoggedIn
            ? [
                { content: t('settings'), link: SELLER_SETTINGS_PATH(locale) },
                { content: t('my_favorite_lots'), link: FAVOURITE_LOTS_PATH(locale) },
                {
                    content: t('my_saved_searches'),
                    link: SAVED_SEARCHES_PATH(locale),
                },
            ]
            : []),
    ];
    return _jsx(FooterColumn, { title: t('footer_link_my_catawiki'), items: items });
};
//# sourceMappingURL=MyCatawiki.js.map